module.exports = __webpack_public_path__ + "img/8.5907ad44.jpg";